<template>
  <div id="installServe">
    <el-input placeholder="请输入产品" v-model="goods" @input="queryProductName" suffix-icon="el-icon-search" />
    <div class="category">
      <div class="categoryTitle">分类</div>
      <div class="categoryContent">
        <div class="categoryItem" v-for="item in productSelectListData" :key="item.id" @click="checkInstallServe(item)">
          <img class="img" :src="`${uploadUrl}${item.produceFile.id}`" alt="" />
          <div class="imgTitle">{{ item.productName }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apis from "@/apis/gzh.js";
export default {
  name: "installServe",
  data() {
    return {
      goods: "",
      productSelectListData: [],
      uploadUrl: ""
    };
  },
  created() {},
  mounted() {
    this.uploadUrl = apis.uploadUrl;
    this.getAllProduct();
  },
  methods: {
    // 获取产品
    getProductList(json) {
      apis.installationDataList(json).then(res => {
        if (res.code === 200) {
          this.productSelectListData = res.data;
        }
      });
    },
    // 获取所有产品
    getAllProduct() {
      const json = {
        page: 1,
        pageSize: 500
      };
      this.getProductList(json)
    },
    // 跳转
    checkInstallServe(item) {
      this.$router.push(`/gzh/mobile/installVideo?id=${item.videoLink}&&productImg=${item.produceFile.id}&&productName=${item.productName}&&videoTitle=${item.videoTitle}`);
    },
    // 搜索
    queryProductName() {
      const json = {
        page: 1,
        pageSize: 500,
        productName: this.goods
      };
      this.getProductList(json)
    }
  }
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  #installServe {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  #installServe {
    width: 276px * $zoom;
  }
}
#installServe {
  font-size: 16px * $zoom;
  padding: 30px 30px 0 30px;
  ::v-deep .el-input--mini {
    width: 100%;
  }
  ::v-deep .el-input__inner {
    height: 72px;
    font-size: 23px;
  }
  ::v-deep .el-input--mini .el-input__icon {
    font-size: 33px;
    display: flex;
    align-items: center;
    margin-right: 10px;
  }
  .category {
    .categoryTitle {
      width: 160px;
      height: 40px;
      line-height: 40px;
      font-size: 35px;
      border-left: 10px solid #00c688;
      padding-left: 10px;
      font-weight: 600;
      color: #282B32;
      margin: 30px 20px 30px 1%;
    }
    .categoryContent {
      display: flex;
      flex-wrap: wrap;
      .categoryItem {
        font-size: 23px;
        width: 33.3333%;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 20px;
        .img {
          width: 128px;
          height: 128px;
          margin-bottom: 10px;
        }
        .imgTitle {
          width: 128px;
          text-align: center;
        }
      }
    }
  }
}
</style>
